import netWorkController from "@/http/netWorkController";
import cookieUtils from "@/utils/cookieUtils";
import toastUtils from "@/utils/toastUtils";
import * as echarts from 'echarts';

export default {
    name: "DeviceStatisticsPage",
    data(){
        return{
            appList:[],
            requestForm:{},
            deviceChart:{},
            deviceStatics:[],
            versionCategoryList:[],
            systemVersionCategoryList:[],
        }
    },
    created() {
        const userInfoStr = window.localStorage.getItem("userInfo")
        if (userInfoStr) {
            this.userInfo = JSON.parse(userInfoStr)
            this.requestForm.accessToken=this.userInfo.accessToken
            this.requestForm.userId=this.userInfo.id
            netWorkController.appList(this.userInfo.id, this.userInfo.accessToken, (result) => {
                if (result.data) {
                    this.appList = result.data
                    let appIdCache = cookieUtils.get("appIdCache")
                    if (appIdCache) {
                        this.requestForm.appId = Number.parseInt(appIdCache);
                    } else {
                        this.requestForm.appId = this.appList[0].id
                    }
                    this.getDeviceStatistics()
                    this.getSystemVersionStatistics()
                    this.getVersionStatistics()
                } else {
                    toastUtils.warning(this, result.msg)
                }
            })
        }
    },
    mounted() {
        let deviceDom = document.getElementById('deviceDom');
        this.deviceChart = echarts.init(deviceDom, null, {
            renderer: 'canvas', useDirtyRect: false
        });
    },
    methods:{
        onchange(value){
            cookieUtils.set("appIdCache", value);
            this.getDeviceStatistics()
            this.getSystemVersionStatistics()
            this.getVersionStatistics()
        },
        getDeviceStatistics(){
            netWorkController.getDeviceStatistics(this.requestForm,(result)=>{
                if (result.status === 200) {
                    let listCount=[]
                    this.deviceStatics=result.data;
                    ///排序
                    this.deviceStatics.sort(function(a, b) {
                        return b.deviceCount - a.deviceCount;
                    });
                    let total=0;
                    for (let i=0;i<this.deviceStatics.length;i++){
                        let device=result.data[i];
                        total=total+device.deviceCount
                        listCount.push({
                            value:device.deviceCount,
                            name:device.deviceManufacturer})
                    }
                    this.deviceStatics.total=total;
                    this.initPie(this.deviceChart,"设备厂商统计",listCount)
                }else {
                    toastUtils.warning(this,result.msg)
                }
            })
        },
        ///APP版本统计
        getVersionStatistics(){
            netWorkController.getVersionStatistics(this.requestForm,(result)=>{
                if (result.status===200){
                    this.versionCategoryList=result.data;
                    for (let i=0;i<this.versionCategoryList.length;i++){
                        let category=this.versionCategoryList[i];
                        category.list.sort(function(a, b) {
                            return b.deviceCount - a.deviceCount;
                        })
                        let total=0;
                        for (let  i=0;i<category.list.length;i++){
                            total=total+category.list[i].deviceCount;
                        }
                        category.total=total
                        setTimeout(()=>{
                            this.initVersionPie(i, category);
                        },300)
                    }
                }else {
                    toastUtils.warning(result.msg)
                }
            })
        },
        //设备系统版本统计
        getSystemVersionStatistics(){
            netWorkController.getSystemVersionStatistics(this.requestForm,(result)=>{
                if (result.status===200){
                    this.systemVersionCategoryList=result.data;
                    for (let i=0;i<this.systemVersionCategoryList.length;i++){
                        let category=this.systemVersionCategoryList[i];
                        category.list.sort(function(a, b) {
                            return b.deviceCount - a.deviceCount;
                        })
                        let total=0;
                        for (let  i=0;i<category.list.length;i++){
                            total=total+category.list[i].deviceCount;
                        }
                        category.total=total
                        setTimeout(()=>{
                            this.initSystemVersionPie(i, category);
                        },300)
                    }
                }else {
                    toastUtils.warning(result.msg)
                }
            })
        },
        ///动态加载APP版本统计饼图
        initVersionPie (i, versionCategory) {
            let domId = 'versionDom_' + i;
            let versionCharts = echarts.getInstanceById(domId)
            if (!versionCharts) {
                const dom = document.getElementById(domId);
                versionCharts = echarts.init(dom, null, {
                    renderer: 'canvas', useDirtyRect: false
                });
            }
            let listCount = []
            for (let i = 0; i < versionCategory.list.length; i++) {
                let device = versionCategory.list[i];
                listCount.push({
                    value: device.deviceCount,
                    name: device.appVersionName
                })
            }
            this.initPie(versionCharts, versionCategory.systemName+"-APP版本统计", listCount)
        },
        initSystemVersionPie (i, versionCategory) {
            let domId = 'systemVersionDom_' + i;
            let versionCharts = echarts.getInstanceById(domId)
            if (!versionCharts) {
                const dom = document.getElementById(domId);
                versionCharts = echarts.init(dom, null, {
                    renderer: 'canvas', useDirtyRect: false
                });
            }
            let listCount = []
            for (let i = 0; i < versionCategory.list.length; i++) {
                let device = versionCategory.list[i];
                listCount.push({
                    value: device.deviceCount,
                    name: device.systemVersion
                })
            }
            this.initPie(versionCharts, versionCategory.systemName+"-系统版本统计", listCount)
        },
        //加载统计饼图
        initPie(eaChart, title, data){
          let  option = {
                title: {
                    text: title,
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {name: 'Access From',
                        type: 'pie',
                        radius: '50%',
                        data: data,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };
            eaChart.setOption(option)
        }
    }

}